<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import '~variables.less';
@import './assets/fonts/iconfont.css';

#app {
  font-family: '-apple-system,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Arial,sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 980px;
  color: #444;
  font-size: 16px;
  line-height: 1.8;
  letter-spacing: 2px;
}

// @media screen and (max-width: 980px) {
//   #app {
//     font-size: 14px;
//   }
// }

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
}

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

img {
  max-width: 100%;
  line-height: 1;
}

h1 { font-size: 32px; font-weight: 600; }
h2 { font-size: 28px; font-weight: 600; }
h3 { font-size: 24px; font-weight: 600; }
h4 { font-size: 20px; font-weight: 600; }
h5 { font-size: 18px; font-weight: 600; }
h6 { font-size: 14px; font-weight: 600; }

.fs-12 { font-size: 12px; }
.fs-14 { font-size: 14px; }
.fs-16 { font-size: 16px; }
.fs-18 { font-size: 18px; }
.fs-20 { font-size: 20px; }
.fs-24 { font-size: 24px; }

.tl { text-align: left; }
.tr { text-align: right; }
.tc { text-align: center; }

.fr { float: right; }
.fl { float: left; }

.m-def{margin:@gutter}
.mt-def{margin-top:@gutter}
.mb-def{margin-bottom:@gutter}
.ml-def{margin-left:@gutter}
.mr-def{margin-right:@gutter}

.m-def-half{margin:@gutter / 2}
.mt-def-half{margin-top:@gutter / 2}
.mb-def-half{margin-bottom:@gutter / 2}
.ml-def-half{margin-left:@gutter / 2}
.mr-def-half{margin-right:@gutter / 2}

.m-def-small{margin:@gutter / 4}
.mt-def-small{margin-top:@gutter / 4}
.mb-def-small{margin-bottom:@gutter / 4}
.ml-def-small{margin-left:@gutter / 4}
.mr-def-small{margin-right:@gutter / 4}

.m-def-large{margin:@gutter*2}
.mt-def-large{margin-top:@gutter*2}
.mb-def-large{margin-bottom:@gutter*2}
.ml-def-large{margin-left:@gutter*2}
.mr-def-large{margin-right:@gutter*2}

.text-primary { color: @color-primary; }
.text-gray { color: @color-gray; }
.text-dark { color: @color-dark; }
.text-green { color: @color-green; }
.text-error { color: @color-error; }
.text-link { color: @color-link; }

.flex{ display:flex }
.flex-sbc{ display:flex;justify-content:space-between;align-items:center }
.flex-sac{ display:flex;justify-content:space-around;align-items:center }
.flex-cc{ display:flex;justify-content:center;align-items:center;text-align:center }
.flex-vc{ display:flex;align-items:center }
.flex-dc{ display:flex;flex-direction: column; }

.min-50vh { min-height: 50vh; }

.strong { font-weight: bold; }

.clearfix {
  &::after {
    display: block;
    content: "";
    clear: both;
  }
}

.text-overflow {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-overflow-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.section-title-words {
  color: @color-gray;
  letter-spacing: 2px;
}

.section-title-line {
  display: inline-block;
  width: 100px;
  height: 4px;
  margin-top: @gutter / 4;
  margin-bottom: @gutter;
  border-radius: 4px;
  background-color: @color-primary;
}

.selection-title-left-line {
  position: relative;
  display: inline-block;
  &::after {
    content: '';
    position: absolute;
    left: -8px;
    top: 7px;
    height: 22px;
    width: 4px;
    border-radius: 4px;
    background-color: @color-primary;
  }
}

.news-item {
  display: flex;
  align-items: center;
  margin-bottom: @gutter;
  &:hover {
    cursor: pointer;
  }
  .news-image {
    width: 200px;
    height: 120px;
    margin-right: @gutter;
    object-fit: cover;
    border: 1px solid #f2f2f2;
    border-radius: 2px;
  }
  .news-content {
    flex: 1;
  }
}

// 有侧边栏时页面的布局
.page-column-layout {
  display: flex;
  flex-direction: column;

  .layout-banner {
    line-height: 1;
    margin-bottom: -2px;
  }

  .layout-wrapper {
    display: flex;
    flex: 1;
  }

  .layout-main {
    flex: 1;
    padding: @gutter @gutter*1.5;
  }
}

// swiper 样式
.swiper-pagination-bullet-active {
  background: @color-primary !important;
}

// elment-ui 样式
.el-pagination {
  margin: @gutter*2 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue